<template>
  <el-form-item label="横向滚动">
    <el-switch v-model="prop.scrollXFlag" size="small"></el-switch>
  </el-form-item>
  <el-form-item label="横轴宽度" v-if="prop.scrollXFlag">
    <el-input-number v-model="prop.xAxisWidth" controls-position="right"></el-input-number>
  </el-form-item>
  <el-form-item label="显示标题">
    <el-switch v-model="prop.showXAxisName" @change="closeXName()" size="small"></el-switch>
  </el-form-item>
  <el-form-item label="标题" v-if="prop.showXAxisName">
    <el-input v-model="prop.xAxisName" size="small"></el-input>
  </el-form-item>
  <el-form-item label="标题字体">
    <el-select v-model="prop.xAxisNameFontFamily" size="small">
      <el-option label="微软雅黑" value="Microsoft YaHei"></el-option>
      <el-option label="宋体" value="SimSun"></el-option>
      <el-option label="黑体" value="SimHei"></el-option>
    </el-select>
  </el-form-item>
  <el-form-item label="标题字号" size="small">
    <el-input-number v-model="prop.xAxisNameFontSize" controls-position="right"></el-input-number>
  </el-form-item>
  <el-form-item label="标题字色">
    <colorPicker v-model="prop.xAxisNameColor"></colorPicker>
  </el-form-item>
  <el-form-item label="显示轴标签">
    <el-switch v-model="prop.axisLabelShow" size="small"></el-switch>
  </el-form-item>
  <el-form-item label="轴标签字体">
    <el-select v-model="prop.xAxisFontFamily" size="small">
      <el-option label="微软雅黑" value="Microsoft YaHei"></el-option>
      <el-option label="宋体" value="SimSun"></el-option>
      <el-option label="黑体" value="SimHei"></el-option>
    </el-select>
  </el-form-item>
  <el-form-item label="轴标签旋转">
    <el-input-number v-model="prop.xAxisRotate" size="small" controls-position="right"></el-input-number>
  </el-form-item>
  <el-form-item label="轴标签字号">
    <el-input-number v-model="prop.xAxisFontSize" size="small" controls-position="right"></el-input-number>
  </el-form-item>
  <el-form-item label="轴标签字色">
    <colorPicker v-model="prop.xAxisColor"></colorPicker>
  </el-form-item>
  <el-form-item label="显示轴线">
    <el-switch v-model="prop.xAxisLineShow" size="small"></el-switch>
  </el-form-item>
  <el-form-item label="轴线粗细">
    <el-input-number v-model="prop.xAxisLineWidth" size="small" controls-position="right"></el-input-number>
  </el-form-item>
  <el-form-item label="隐藏刻度线">
    <el-switch v-model="prop.xAxisTickHide" size="small"></el-switch>
  </el-form-item>
  <el-form-item label="轴线颜色">
    <colorPicker v-model="prop.xAxisLineColor"></colorPicker>
  </el-form-item>
  <el-form-item label="显示">
    <el-switch v-model="prop.xAxisShow" size="small"></el-switch>
  </el-form-item>
  <el-form-item label="显示网格线">
    <el-switch v-model="prop.xAxisSplitLineShow" size="small"></el-switch>
  </el-form-item>
  <el-form-item label="开启网格虚线">
    <el-switch v-model="prop.xAxisSplitLineShowDotted" size="small"></el-switch>
  </el-form-item>

  <template v-if="prop.xAxisSplitLineShowDotted">
    <el-form-item label="实线宽度">
      <el-input-number
          v-model="prop.xAxisSplitLineOne"
          size="small"
          controls-position="right"
      ></el-input-number>
    </el-form-item>
    <el-form-item label="间隔宽度">
      <el-input-number
          v-model="prop.xAxisSplitLineTwo"
          size="small"
          controls-position="right"
      ></el-input-number>
    </el-form-item>
  </template>
  <el-form-item label="网格线颜色">
    <colorPicker v-model="prop.xAxisSplitLineColor"></colorPicker>
  </el-form-item>
  <el-form-item label="标签分割间隔">
    <el-input-number v-model="prop.xAxisInterval" min="0" size="small"></el-input-number>
  </el-form-item>
  <el-form-item label="轴反转">
    <el-switch v-model="prop.xAxisInverse" size="small"></el-switch>
  </el-form-item>
  <el-form-item label="区域缩放">
    <el-switch @change="scaleChange" v-model="prop.showDataZoom" size="small"></el-switch>
  </el-form-item>
</template>
<script setup>
import colorPicker from "./color-picker.vue";

let props = defineProps({
  prop: {},
});

function closeXName() {
  if (!props.prop.showXAxisName) {
    props.prop.xAxisName = ''
  }
}

function scaleChange(v) {
  // 自动调整底部间距
  if (v) {
    if (props.prop.gridY2 < 80) {
      props.prop.gridY2 = 80
    }
  } else {
    props.prop.gridY2 = 25
  }
}
</script>
<style scoped></style>